import React from 'react';
import { usePriceRowContext } from '../../../price-row-context';
import RatingSmiley from 'src/components/rating/smiley-rating';
import { RatingContainer } from './styles';
import { MediumUp, MobileOnly } from 'src/ui/block';

type Props = {
  newOfferItemExperiment?: boolean;
};

export const StoreRatingAverage: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<Props>
>> = props => {
  const { newOfferItemExperiment } = props;
  const { isFeatured = false, offer } = usePriceRowContext();
  const { store, rating } = offer;

  if (!store || !rating || rating.whole <= 0) {
    return null;
  }

  return (
    <RatingContainer data-rating={rating.roundedString}>
      <MobileOnly>
        <RatingSmiley
          featured={isFeatured}
          rating={rating}
          scoreVisibility="row"
          size={newOfferItemExperiment ? 'normal' : 'small'}
        />
      </MobileOnly>

      <MediumUp>
        <RatingSmiley
          featured={isFeatured}
          rating={rating}
          scoreVisibility="row"
          size="small"
          reviewCount={store.userReviewSummary.countTotal}
        />
      </MediumUp>
    </RatingContainer>
  );
};
